import { LeftCircleFilled } from "@ant-design/icons";
import { Divider } from "antd";
import CustomAlert from "components/common/Alert/Alert";
import FormularioEditarPlantaAlimentos from "components/PlantaAlimentos/FormularioEditar";
import React from "react";
import { useNavigate } from "react-router-dom";

function EditarPlantaAlimentos() {
  const navigate = useNavigate();
  const [message, setMessage] = React.useState("");
  const [isVisible, setIsVisible] = React.useState(false);
  const [title, setTitle] = React.useState("");
  const [alertType, setAlertType] = React.useState("");

  const getMessage = (message) => {
    setMessage(message.message);
    setIsVisible(true);
    setAlertType(message.type);
    setTitle(message.title);
    window.scrollTo({ top: 0, behavior: "smooth" });

    setTimeout(() => {
      setIsVisible(false);
      navigate(-1);
    }, 10000);
  };
  return (
    <>
      <div
        className="crear-planta__header"
        // style={{ paddingLeft: "2rem", cursor: "pointer" }}
        onClick={() => navigate(-1)}
      >
        <LeftCircleFilled /> Formulario de Planta de alimentos
      </div>
      <Divider />
      <CustomAlert
        isVisible={isVisible}
        title={title}
        type={alertType}
        description={message}
        showIcon
      />
      <div style={{ paddingBottom: "150px" }}>
        <FormularioEditarPlantaAlimentos message={getMessage} />
      </div>
    </>
  );
}

export default EditarPlantaAlimentos;
